const { pipe, flip, sum, subtract, multiply, divide, map } = require('ramda');

const multiplier = 1000;

class Currency {
  /**
   * Calculates the sum of an array of numbers
   * @param {array} numbers
   */
  static sum(numbers) {
    return pipe(map(multiply(multiplier)), sum, flip(divide)(multiplier))(numbers);
  }

  /**
   * Subtracts one number from another number
   * @param {minuend} number - The part you start with
   * @param {subtrahend} number - The part being taken away
   */
  static subtract(minuend, subtrahend) {
    return divide(subtract(multiply(minuend, multiplier), multiply(subtrahend, multiplier)))(multiplier);
  }
}

export default Currency;
